import {Box, Skeleton} from '@mantine/core';
import type {FC} from 'react';
import {RegistBox} from '../../../shared/components/RegistBox';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

type Props = {
  isStudentVerificationRequired?: boolean;
};

export const NoLoginListBox: FC<Props> = ({
  isStudentVerificationRequired = false,
}) => {
  const {isPC} = useMediaQuery();

  return (
    <Box className="relative w-full pc:max-w-[70%] max-w-[95%]">
      <Box className="grid pc:gap-12 pc:grid-cols-3 bg-white rounded-4 rounded-b-12 px-16 py-24">
        {Array.from({length: isPC ? 6 : 1}).map(() => (
          <Box className="flex flex-col gap-12 blur-sm mb-12">
            <Skeleton height={200} animate={false} />
            <Skeleton height={16} animate={false} />
            <Skeleton height={16} animate={false} />
            <Skeleton height={16} animate={false} width={200} />
          </Box>
        ))}
      </Box>

      <RegistBox
        text="新規会員登録またはログインすることで、動画を視聴できます。"
        studentVerificationText="大学認証を完了することで、動画を視聴できます。"
        isStudentVerificationRequired={isStudentVerificationRequired}
      />
    </Box>
  );
};
